import React, { Component } from "react";
import { connect } from "react-redux";

//MUI
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    state
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

//Styles
const styles = theme => ({
  root: {}
});

class LogSettings extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography>log settings</Typography>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LogSettings));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/log_tabs/LogSettings.js